import { Media } from "./media";

export interface Video {
    id: number;
    name: string;
    description: string;
    media: Media[];
    created_by: number;
    created_by_name: string;
    created_by_email: string;
    created_at: Date;
    changed_by: number;
    changed_at: Date;
}

export const emptyVideo: Video = {
    id: 0,
    name: '',
    description: '',
    media: [],
    created_by: 0,
    created_by_name: '',
    created_by_email: '',
    created_at: new Date(),
    changed_by: 0,
    changed_at: new Date()
}